/* global window */

'use strict';

const { isExternalLink, personalizedSlice } = require('../lib/util.js');
const performanceMeasure = require('../lib/performanceMeasure.js');
let measure = performanceMeasure('bootscripts:analytics');

(function () {
    let q = window.phoenixTrackClickEvent._q || [];
    let tracker = function (
        el,
        event,
        action = 'click',
        trackIdAttr = 'phx-track-id',
        isPersonalized = false
    ) {
        const href = el.getAttribute('href');
        let adobeTracker = el.getAttribute('phoenix-adobe-tracker');

        if (window.googleAnalytics) {
            const customMap = {};
            const elem = el.getAttribute('phx-track-id') || _getElementPath(el);
            if (elem) {
                customMap['click_element'] = elem;
            }
            const text = el.textContent || el.getAttribute('title');
            if (text) {
                customMap['click_text'] = el.textContent || el.getAttribute('title');
            }

            // The following lines are used to store the container of the clicked element.
            // This piece of data is used in the page_view event,
            // specifically the `source_click_container` event parameter.
            const pathArray = _getTrackablePathArray(el);
            const clickContainer = pathArray?.length ? pathArray[0] : null;
            if (clickContainer) {
                window.sessionStorage?.setItem?.('phx-track-container', clickContainer);
            }

            const onclickValue = el.getAttribute('onclick');
            const urlMatch = onclickValue?.match(/window\.open\('([^']*)'/);
            if (urlMatch && urlMatch.length > 1) {
                let url = urlMatch[1];
                customMap['click_url'] = url;
            } else {
                customMap['click_url'] = window.location.href;
            }

            window.googleAnalytics.sendEvent(
                'Page Interaction',
                action,
                _getElementPath(el),
                null,
                customMap
            );

            if (href) {
                customMap['click_url'] = href;
            }

            if (href && isExternalLink(href)) {
                window.googleAnalytics.sendEvent('Outbound Link', 'click', href, null, customMap);
            }

            window.sendEventFromElement(el);
        }

        // Adobe Analytics
        if (adobeTracker && window.adobeAnalytics && window.adobeAnalytics.s) {
            adobeTracker = JSON.parse(adobeTracker);
            if (adobeTracker.trackId) {
                window.adobeAnalytics.s.linkTrackVars = adobeTracker.trackVars || 'eVar13,eVar63,events';
                window.adobeAnalytics.sendEvent(el, adobeTracker.linkName || 'Social Share', {
                    eVar13: adobeTracker.trackId,
                    events: 'event2',
                });
            }
        }

        return !!(href && href.length);

        function _getElementPath(element) {
            return _getTrackablePathArray(element).join('/');
        }

        function _getTrackablePathArray(element) {
            if (!element || element.tagName?.toLowerCase() === 'body') {
                return [];
            }

            // get the trackable array for the parent
            let trackableArray = _getTrackablePathArray(element.parentNode);

            // add this element's track id to the array if it exists
            let elementTrackId = element.getAttribute?.(trackIdAttr);
            if (elementTrackId) {
                // Special case for an expanded panel or subpanel. The links are children
                // of an element dynamically added to the DOM; we want to treat the previous
                // sibling as our target element, and not include the dynamic element in
                // the sibling count.
                let findId = elementTrackId.replace(/-expanded$/, '');
                if (findId !== elementTrackId) {
                    element = element.previousSibling;
                    elementTrackId = findId;
                }
                let elementTrackIndex = _getTrackableIndex(element, elementTrackId);
                trackableArray.push(elementTrackId + elementTrackIndex);
            }
            return trackableArray;

            function _getTrackableIndex(element, id) {
                let indexString = '';
                let siblings = [...element.parentNode.querySelectorAll(`[${trackIdAttr}="${id}"]`)];
                if (siblings.length > 1) {
                    let index = siblings.indexOf(element);

                    if (index > -1) {
                        indexString = `(${index + 1})`;
                    }
                }

                return indexString;
            }
        }
    };

    window.sendEventFromElement = function (element) {
        if (!window.googleAnalytics) {
            return;
        }

        const category = element.getAttribute('phx-ga-category');
        const action = element.getAttribute('phx-ga-action');
        const label = element.getAttribute('phx-ga-label');

        if (!category || !action || !label) {
            return;
        }

        window.googleAnalytics.sendEvent(category, action, label);
    };

    window.phoenixTrackClickEvent = tracker;

    window.phoenixStopEventPropagation = function (event) {
        event.stopPropagation();
    };

    window.phoenixTrackRecommendationClickEvent = function (trigger, url, widgetName, isPersonalized, type) {
        const pat = /^https?:\/\//i;
        const fullURL = pat.test(url) ? url : window.location.protocol + '//' + window.location.host + url;
        //  LiftIgniter Tracker
        if (window.$p && url && widgetName && widgetName !== 'undefined') {
            var evt = 'widget_click';
            var ctx = {
                w: isPersonalized ? widgetName : widgetName.replace('tempest_', 'tempestn_'),
                loader: 'tempest',
                ...(isPersonalized || { source: 'base' }),
                ...(url && { clickUrl: fullURL }),
                ...(trigger && { trigger: trigger }),
            };
            window.$p('sendRobust', evt, ctx);
        }

        return true;
    };

    if (q && q.length > 0) {
        q.forEach((el) => tracker(el));
    }
})();

measure.end();
